export default "__VITE_ASSET__Bs46zBcA__"